"use client";

// @ts-strict-ignore
import * as React from "react";

import type { CoinDetailType } from "types/prices";

const CoinDetailsContext = React.createContext<CoinDetailType | null>(null);

export const CoinDetailsProvider = ({
  coinDetails,
  children
}: {
  children: React.ReactNode;
  coinDetails?: CoinDetailType;
}) => {
  return (
    <CoinDetailsContext.Provider value={coinDetails}>
      {children}
    </CoinDetailsContext.Provider>
  );
};

/**
 * Context hook to access coin detail information from Contentful in the /prices/[...coin] page
 */
export const useCoinDetails = () => {
  const context = React.useContext(CoinDetailsContext);

  return context;
};
